export const products = [
  { slug: 'limoncello', title: 'Limoncello', card: '/assets/product-limoncello-card.avif' },
  { slug: 'whiskey', title: 'Whisky', card: '/assets/product-whiskey-card.avif' },
  { slug: 'vodka', title: 'Vodka', card: '/assets/product-vodka-card.avif' },
  { slug: 'gin', title: 'Gin', card: '/assets/product-gin-card.avif' },
  { slug: 'pinkgin', title: 'Pink Gin', card: '/assets/product-pinkgin-card.avif' },
  { slug: 'rum', title: 'Rum', card: '/assets/product-rum-card.avif' },
]

export const productOptions = {
  formaat: ['50 ml', '200 ml', '500 ml', '700 ml', '4500 ml', 'Weet ik nog niet'],
  aantallen: ['1 - 36', '36 - 90', '90 - 180', '180 - 300', '300 - 450', '450 - +++', 'Weet ik nog niet'],
  etiket: [
    'Alleen voor- en achterkant',
    'Voor- en achterkant + dopsticker + kaartje',
    'Voor- en achterkant + dopsticker',
    'Voor- en achterkant + kaartje',
    'Geen etiket',
    'Weet ik nog niet',
  ],
  etiketVorm: ['Rond', 'Rechthoek', 'Halfrond', 'Custom'],
  kaartVorm: ['Rond', 'Ovaal', 'Rechthoekig', 'Eigen contour', 'Weet ik nog niet'],
  dopsticker: ['Ja', 'Nee', 'Weet ik nog niet'],
}

export const serviceItems = [
  {
    title: 'BOTTELEN',
    icon: 'bottle',
    text: 'Onze toewijding aan kwaliteit, innovatie en persoonlijke ondersteuning onderscheidt ons in de wereld van kleine oplage bottelen. We zijn hier om jouw merk te laten schitteren, fles per fles.',
  },
  {
    title: 'SMALL BATCHES',
    icon: 'box',
    text: 'Of je nu ambachtelijke dranken, unieke dranken of welke vloeibare creatie dan ook maakt, wij hebben de apparatuur en expertise om jouw visie tot leven te brengen.',
  },
  {
    title: 'PRIVATE LABEL',
    icon: 'tag',
    text: 'Of het nu gaat om een specifiek smaakprofiel of een label dat de essentie van jouw merk vastlegt, we werken nauw met je samen om een product te creëren dat net zo uniek is als jouw visie.',
  },
  {
    title: 'A TOT Z',
    icon: 'puzzle',
    text: 'We werken nauw met je samen om een product te creëren dat net zo uniek is als jouw visie. Van glas, vloeistof, dop, tot etiket en capsule.',
  },
  {
    title: 'EIGEN RECEPT',
    icon: 'tube',
    text: 'Of je nu ambachtelijke dranken, unieke dranken of welke vloeibare creatie dan ook maakt, wij hebben de apparatuur en expertise om jouw visie tot leven te brengen.',
  },
  {
    title: 'CONSULT / AGENCY',
    icon: 'brain',
    text: 'Bij The Bottling Club zijn we meer dan alleen een bottelbedrijf; we zijn jouw toegangspoort tot een wereld vol mogelijkheden voor nieuwe en kleine merken in de drankindustrie',
  },
]

export const legalSections = [
  ['Artikel 1 - Definities', [
    'The Bottling Club BV: De besloten vennootschap, gevestigd te Weg en Land 39A, 2661 DC, Bergschenhoek ingeschreven bij de Kamer van Koophandel onder nummer 87471515, die afvul- en productontwikkelingsdiensten aanbiedt.',
    'Opdrachtgever: De natuurlijke of rechtspersoon die met The Bottling Club BV een overeenkomst sluit voor het leveren van diensten of producten.',
    'Overeenkomst: De schriftelijke of elektronische overeenkomst tussen The Bottling Club BV en de Opdrachtgever met betrekking tot de levering van diensten of producten.',
    'Diensten: Alle werkzaamheden die The Bottling Club BV uitvoert, waaronder maar niet beperkt tot bottelen, receptontwikkeling, labelontwerp en merkondersteuning.',
    'Producten: De door The Bottling Club BV geleverde goederen, zoals gebottelde dranken of verpakkingsmaterialen.',
  ]],
  ['Artikel 2 - Toepasselijkheid', [
    'Deze algemene voorwaarden zijn van toepassing op alle offertes, overeenkomsten en leveringen van The Bottling Club BV, tenzij schriftelijk anders overeengekomen.',
    'Afwijkingen van deze voorwaarden zijn alleen geldig indien deze uitdrukkelijk en schriftelijk zijn overeengekomen.',
    'De algemene voorwaarden van de Opdrachtgever zijn niet van toepassing, tenzij The Bottling Club BV deze uitdrukkelijk schriftelijk heeft aanvaard.',
  ]],
  ['Artikel 3 - Offertes en Overeenkomsten', [
    'Alle offertes van The Bottling Club BV zijn vrijblijvend, tenzij anders vermeld, en hebben een geldigheidsduur van 30 dagen.',
    'Een overeenkomst komt tot stand zodra de Opdrachtgever de offerte schriftelijk of elektronisch aanvaardt, of zodra The Bottling Club BV een opdrachtbevestiging verstuurt.',
    'The Bottling Club BV behoudt zich het recht voor om opdrachten te weigeren zonder opgave van redenen.',
  ]],
  ['Artikel 4 - Prijzen en Betaling', [
    'Alle prijzen zijn exclusief btw en andere heffingen, tenzij anders vermeld.',
    'Betaling dient te geschieden binnen 14 dagen na factuurdatum, tenzij anders overeengekomen.',
    'Bij niet-tijdige betaling is de Opdrachtgever van rechtswege in verzuim en is een vertragingsrente verschuldigd van 1% per maand over het openstaande bedrag.',
    'The Bottling Club BV behoudt zich het recht voor om de uitvoering van de overeenkomst op te schorten bij niet-tijdige betaling.',
  ]],
  ['Artikel 5 - Levering en Uitvoering', [
    'The Bottling Club BV zal de diensten en producten leveren conform de specificaties in de overeenkomst.',
    'Levertijden zijn indicatief en geen fatale termijnen, tenzij uitdrukkelijk anders overeengekomen.',
    'The Bottling Club BV is gerechtigd om de uitvoering van de overeenkomst in fasen uit te voeren en tussentijds te factureren.',
  ]],
  ['Artikel 6 - Kwaliteit en Klachten', [
    'The Bottling Club BV garandeert dat de geleverde producten en diensten voldoen aan de overeengekomen specificaties en de wettelijke eisen.',
    'Klachten over de geleverde diensten of producten dienen binnen 7 dagen na levering schriftelijk te worden gemeld, met een duidelijke omschrijving van de klacht.',
    'Indien een klacht gegrond is, zal The Bottling Club BV naar eigen keuze het product vervangen, de dienst opnieuw uitvoeren of een redelijke compensatie bieden.',
  ]],
  ['Artikel 7 - Intellectueel Eigendom', [
    'Alle rechten van intellectueel eigendom met betrekking tot recepturen, ontwerpen, labels en andere materialen ontwikkeld door The Bottling Club BV blijven eigendom van The Bottling Club BV, tenzij anders overeengekomen.',
    'De Opdrachtgever verkrijgt een niet-exclusieve gebruikslicentie voor de geleverde ontwerpen en materialen, uitsluitend voor het doel waarvoor deze zijn verstrekt.',
  ]],
  ['Artikel 8 - Aansprakelijkheid', [
    'The Bottling Club BV is uitsluitend aansprakelijk voor directe schade als gevolg van een toerekenbare tekortkoming, tot maximaal het factuurbedrag van de betreffende overeenkomst.',
    'The Bottling Club BV is niet aansprakelijk voor indirecte schade, zoals gederfde winst of reputatieschade.',
    'De Opdrachtgever vrijwaart The Bottling Club BV voor aanspraken van derden met betrekking tot de door de Opdrachtgever verstrekte materialen of instructies.',
  ]],
  ['Artikel 9 - Overmacht', [
    'The Bottling Club BV is niet gehouden tot het nakomen van enige verplichting indien zij daartoe verhinderd is door overmacht, zoals stakingen, brand, natuurrampen of overheidsmaatregelen.',
    'Bij overmacht wordt de uitvoering van de overeenkomst opgeschort zolang de overmachtsituatie voortduurt. Indien de overmacht langer dan 30 dagen duurt, hebben beide partijen het recht de overeenkomst te ontbinden zonder schadevergoeding.',
  ]],
  ['Artikel 10 - Annulering en Ontbinding', [
    'Annulering van een overeenkomst door de Opdrachtgever is alleen mogelijk met schriftelijke toestemming van The Bottling Club BV.',
    'Bij annulering is de Opdrachtgever verplicht de reeds gemaakte kosten en een redelijke vergoeding voor gederfde inkomsten te betalen.',
    'The Bottling Club BV kan de overeenkomst ontbinden bij niet-nakoming door de Opdrachtgever, zonder dat rechterlijke tussenkomst vereist is.',
  ]],
  ['Artikel 11 - Vertrouwelijkheid', [
    'Beide partijen zijn verplicht tot geheimhouding van alle vertrouwelijke informatie die zij in het kader van de overeenkomst verkrijgen.',
    'The Bottling Club BV zal recepturen en andere gevoelige informatie van de Opdrachtgever niet zonder toestemming delen met derden.',
  ]],
  ['Artikel 12 - Toepasselijk Recht en Geschillen', [
    'Op alle overeenkomsten tussen The Bottling Club BV en de Opdrachtgever is Nederlands recht van toepassing.',
    'Geschillen worden voorgelegd aan de bevoegde rechter in het arrondissement waar The Bottling Club BV is gevestigd, tenzij dwingendrechtelijke regels anders bepalen.',
  ]],
  ['Artikel 13 - Wijziging van Voorwaarden', [
    'The Bottling Club BV behoudt zich het recht voor deze algemene voorwaarden te wijzigen.',
    'Wijzigingen worden van kracht 30 dagen na bekendmaking aan de Opdrachtgever, tenzij anders overeengekomen.',
  ]],
]

